if (!customElements.get('kosai-sale-hero')) {
  class KosaiSaleHero extends HTMLElement {
    connectedCallback() {
      this.cleanup = [];
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.video = this.querySelector('video');
      this.motion = this.querySelector('.kn-motion');
      this.messages = this.querySelector('.kn-motion-messages');
      this.vitrine = this.querySelector('.kn-vitrine');
      const listen = (target, type, fn, options) => {
        target.addEventListener(type, fn, options);
        this.cleanup.push(() => target.removeEventListener(type, fn, options));
      };
      this.sync = () => {
        this.classList.toggle('kn-paused', this.paused);
        this.motion.setAttribute('aria-pressed', String(this.paused));
        this.motion.textContent = this.paused ? this.motion.dataset.playLabel : this.motion.dataset.pauseLabel;
        if (this.video) {
          if (this.paused || document.hidden || this.reduced.matches || this.visible === false) this.video.pause();
          else if (this.video.src) this.video.play().catch(() => {});
        }
      };
      listen(this.motion, 'click', () => { this.paused = !this.paused; this.sync(); });
      listen(this.reduced, 'change', () => { this.paused = this.reduced.matches; this.sync(); });
      listen(document, 'visibilitychange', this.sync);
      if (this.video) {
        listen(this.video, 'loadeddata', () => { this.classList.add('kn-video-ready'); this.sync(); });
        const observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible && !this.video.src && !this.reduced.matches && !navigator.connection?.saveData) {
            this.video.src = this.video.dataset.videoSrc;
            this.video.load();
          }
          this.sync();
        }, {rootMargin: '100px'});
        observer.observe(this);
        this.cleanup.push(() => observer.disconnect());
      }
      listen(this, 'pointermove', event => {
        if (this.paused || this.reduced.matches || event.pointerType !== 'mouse') return;
        const box = this.getBoundingClientRect();
        this.vitrine.style.setProperty('--kn-ry', (((event.clientX-box.left)/box.width-.5)*10)+'deg');
        this.vitrine.style.setProperty('--kn-rx', (((event.clientY-box.top)/box.height-.5)*-7)+'deg');
      }, {passive:true});
      listen(this, 'pointerleave', () => {
        this.vitrine.style.setProperty('--kn-ry','0deg');
        this.vitrine.style.setProperty('--kn-rx','0deg');
      });
      this.querySelectorAll('[data-coupon]').forEach(button => listen(button, 'click', async () => {
        const status = this.querySelector('.kn-copy-status');
        try {
          await navigator.clipboard.writeText(button.dataset.coupon);
          status.textContent = this.messages.dataset.copied;
        } catch {
          status.textContent = this.messages.dataset.copyError + ' ' + button.dataset.coupon;
        }
      }));
      this.sync();
    }
    disconnectedCallback() {
      this.cleanup?.forEach(fn => fn());
      this.video?.pause();
    }
  }
  customElements.define('kosai-sale-hero', KosaiSaleHero);
}